import { lazy } from 'react';
import { RouteConfig } from 'react-router-config';

export const productApprovalRoutes = (): RouteConfig[] => [
  {
    path: '/product-approval',
    exact: true,
    name: '产品审批',
    component: lazy(() => import('@/presentation/pages/product-approval')),
    hideInMenu: true,
  },
  {
    path: '/product-approval/details',
    exact: true,
    name: '申请详情',
    component: lazy(() => import('@/presentation/pages/product-approval/details')),
    hideInMenu: true,
  },
];

export default productApprovalRoutes;
